import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './ErrorBoundary';
import { isLoggedIn } from './auth';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// 注册 Service Worker (PWA 离线支持) — split 用相对路径, 确保在 /split 作用域下注册
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('sw.js').catch(err => console.error('SW registration failed:', err));
    // SW 接管页面后, 再触发一次同步+预取, 确保预取请求被 SW 拦截并写入缓存
    navigator.serviceWorker.ready.then(() => {
      if (isLoggedIn()) {
        import('./sync').then(m => m.triggerAutoSync()).catch(() => {});
      }
    }).catch(() => {});
  });
}
